import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "bootstrap/dist/css/bootstrap.min.css";
import * as serviceWorkerRegistration from './serviceWorkerRegistration.js';


import { LanguageProvider } from "./context/LanguageContext.jsx";

const root = ReactDOM.createRoot(
  document.getElementById("root")
);

root.render(
  <React.StrictMode>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </React.StrictMode>
);

// ...after ReactDOM render
serviceWorkerRegistration.register();